import React, { useState } from 'react'
import { Row, Container, Card, ListGroup, Breadcrumb, InputGroup, FormControl, Col } from 'react-bootstrap'
import HeaderSupport from '../../Components/HeaderSupport'
import Bannersupport from '../../Assets/TempExample//ExampleGuides.png'
import ImageIconLoader from '../../Components/ImageIconLoader'
import TestimonialSection from '../../Components/TestimonialSection'
import Footer from '../../Components/FooterSupport'

const Index: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const handleSearch = (event: any) => {
    const term = event.target.value;
    setSearchTerm(term);
    if (term === '') {
    } else {
    }
  };
  return (
    <div className='position-relative'>
      <HeaderSupport />
      <div className='guides_banner'>
        <div className="guides_banner-container container-fluid ">
          <div className='px-4 col-4'>
            <div className='mx-3'>
              <Breadcrumb>
                <Breadcrumb.Item href="#">Suport</Breadcrumb.Item>
                <Breadcrumb.Item active>Case Studies</Breadcrumb.Item>
              </Breadcrumb>
            </div>
            <div>
              <h1 className=' text-white'>
                Case Studies
              </h1>
              <p className='text-white'>
                Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod.
              </p>
              <InputGroup className="search-input">
                <FormControl
                  placeholder="Search"
                  value={searchTerm}
                  onChange={handleSearch}
                />
                <InputGroup.Text className="search-icon">
                  <ImageIconLoader name={"iconsearch"} alt="" width={30} />
                </InputGroup.Text>
              </InputGroup>
            </div>
          </div>

        </div>

      </div>
      <Container >
        {['PES Markets', 'Predict Program Size', 'Geotargeting'].map((item, index) => (
          <section className='p-4'>
            {/* <div className='guide_header m-3'>
              <h4 className='guide_title_sec'>
                {item}
              </h4>
              <p className='guide_desc'>
                Dive into our series of interactive training guides designed to equip you with comprehensive knowledge and practical skills for navigating PES. Whether you’re seeking to refine your PES expertise or you’re just getting started, our immersive walk-throughs offer the perfect learning experience tailored to your needs.
              </p>
            </div> */}

            <div className='d-flex justify-content-between p-0'>


              <TestimonialSection
                title="Women Achieve Self-Sufficiency and Success"
                description="Gray DI data on high-demand job skills allowed Fresh Start to fast-track program participants into the right job opportunities."
                quote="The PES platform has opened doors for our program participants to in-demand, high-growth career opportunities with companies like Boeing and Microsoft."
                authorName="Abdu Dahr"
                authorTitle="Vice President of Strategic Partnerships Fresh Start"
                authorImage="https://cdn-icons-png.flaticon.com/512/3135/3135823.png"
                invert={index % 2 !== 0}// Sustituye por una URL válida de imagen
              />

            </div>
          </section >
        ))}
      </Container>


      <Footer />

    </div >
  )
}

export default Index